module.exports = __webpack_public_path__ + "img/mizhi-back-second.8a829fe7.png";